// oldpassion, Jailbird Memory: Aufwärmrunde auf der Startseite (sections/memory-promo.liquid).
// Zwei Paare, eine Uhr, dann der Weg zum echten Spiel. Reine Logik oben (Tests in
// memory-promo.test.mjs), DOM-Teil unten. Kein Backend, kein Code, nichts wird gespeichert.

export function pickDeck(faces, rng = Math.random) {
  const pool = faces.slice();
  const a = pool.splice(Math.floor(rng() * pool.length), 1)[0];
  const b = pool.splice(Math.floor(rng() * pool.length), 1)[0];
  const deck = [a, a, b, b].map((face, id) => ({ id, face }));
  for (let i = deck.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [deck[i], deck[j]] = [deck[j], deck[i]];
  }
  return deck.map((c, id) => ({ ...c, id }));
}

export function createMini(deck, now = () => Date.now()) {
  const s = { up: [], matched: new Set(), locked: false, startedAt: 0, solvedAt: 0 };
  return {
    flip(id) {
      if (s.locked || s.solvedAt || s.matched.has(id) || s.up.includes(id)) return { type: "ignore" };
      if (!s.startedAt) s.startedAt = now();
      s.up.push(id);
      if (s.up.length < 2) return { type: "up", id };
      const [x, y] = s.up;
      if (deck[x].face.src === deck[y].face.src) {
        s.matched.add(x); s.matched.add(y); s.up = [];
        if (s.matched.size === deck.length) {
          s.solvedAt = now();
          return { type: "solved", ids: [x, y], ms: s.solvedAt - s.startedAt };
        }
        return { type: "match", ids: [x, y] };
      }
      s.locked = true;
      return { type: "miss", ids: [x, y] };
    },
    unlock() { s.up = []; s.locked = false; },
    elapsed() { return s.startedAt ? (s.solvedAt || now()) - s.startedAt : 0; },
    running() { return !!s.startedAt && !s.solvedAt; },
    solved() { return !!s.solvedAt; },
  };
}

export function formatSeconds(ms) {
  return (Math.max(0, ms) / 1000).toFixed(1) + " s";
}

export function mountPromo(root) {
  let faces = [];
  try { faces = JSON.parse(root.getAttribute("data-mgp-faces") || "[]"); } catch (e) { faces = []; }
  if (faces.length < 2) return;
  const grid = root.querySelector("[data-mgp-grid]");
  const status = root.querySelector("[data-mgp-status]");
  const clock = root.querySelector("[data-mgp-clock]");
  const done = root.querySelector("[data-mgp-done]");
  const again = root.querySelector("[data-mgp-again]");
  const cta = root.closest(".mgp") && root.closest(".mgp").querySelector(".mgp__cta");
  const t = (k) => root.getAttribute("data-t-" + k) || "";
  const reduce = typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion: reduce)").matches;
  let deck, game, tick = 0;

  const cardEl = (id) => grid.querySelector("[data-id='" + id + "']");

  function render() {
    grid.innerHTML = "";
    deck.forEach((c, i) => {
      const b = document.createElement("button");
      b.type = "button"; b.className = "mgp-card"; b.dataset.id = String(c.id); b.style.setProperty("--i", String(i));
      b.setAttribute("aria-label", t("card") + " " + (i + 1) + " von " + deck.length); b.setAttribute("aria-pressed", "false");
      b.innerHTML = '<span class="mgp-card__inner"><span class="mgp-card__back" aria-hidden="true"></span>' +
        '<span class="mgp-card__face"><img class="mgp-card__img" src="' + c.face.src + '" alt="" decoding="async"></span></span>';
      grid.appendChild(b);
    });
  }

  function setUp(id, up) {
    const el = cardEl(id); if (!el) return;
    el.classList.toggle("is-up", up); el.setAttribute("aria-pressed", up ? "true" : "false");
    el.setAttribute("aria-label", (up ? t("open") : t("card")) + " " + (Number(el.dataset.id) + 1) + " von " + deck.length);
  }

  function stopClock() { if (tick) { clearInterval(tick); tick = 0; } }
  function startClock() {
    stopClock();
    tick = setInterval(() => { if (clock) clock.textContent = formatSeconds(game.elapsed()); }, 100);
  }

  function reset() {
    stopClock();
    deck = pickDeck(faces); game = createMini(deck);
    deck.forEach((c) => { const im = new Image(); im.src = c.face.src; });
    render();
    if (clock) clock.textContent = formatSeconds(0);
    if (status) status.textContent = t("start");
    if (done) done.classList.add("is-off");
    root.classList.remove("is-solved");
    if (cta) cta.classList.remove("is-hot");
  }

  grid.addEventListener("click", (ev) => {
    const el = ev.target.closest(".mgp-card"); if (!el) return;
    const id = Number(el.dataset.id);
    const r = game.flip(id);
    if (r.type === "ignore") return;
    if (!tick && game.running()) startClock();
    setUp(id, true);
    if (r.type === "up") { if (status) status.textContent = t("one"); return; }
    if (r.type === "miss") {
      const wait = reduce ? 250 : 700;
      setTimeout(() => {
        r.ids.forEach((x) => { const c = cardEl(x); if (c) c.classList.add("is-wrong"); });
        setTimeout(() => { r.ids.forEach((x) => { setUp(x, false); const c = cardEl(x); if (c) c.classList.remove("is-wrong"); }); game.unlock(); }, reduce ? 0 : 320);
      }, wait);
      if (status) status.textContent = t("miss");
      return;
    }
    r.ids.forEach((x) => { const c = cardEl(x); if (c) { c.classList.add("is-matched"); c.setAttribute("aria-label", t("matched")); } });
    if (r.type === "match") { if (status) status.textContent = t("pair"); return; }
    stopClock();
    if (clock) clock.textContent = formatSeconds(r.ms);
    if (status) status.textContent = t("done").replace("{t}", formatSeconds(r.ms));
    if (done) done.classList.remove("is-off");
    root.classList.add("is-solved");
    if (cta) { cta.classList.add("is-hot"); try { cta.focus({ preventScroll: true }); } catch (e) {} }
  });

  if (again) again.addEventListener("click", (ev) => { ev.preventDefault(); reset(); });
  if (typeof IntersectionObserver === "function") {
    root.classList.add("mgp-io");
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { root.classList.add("is-in"); io.disconnect(); }
    }, { threshold: 0.3 });
    io.observe(root);
  }
  reset();
}

if (typeof document !== "undefined") {
  document.querySelectorAll("[data-mgp]").forEach((root) => mountPromo(root));
}
